<uni-accordion *ngIf="creationRequest$ | async as creationRequest">
  <uni-accordion-group heading="Información del Solicitante">
    <uni-accordion-item name="Fideicomiso" [description]="creationRequest.escrow.sNombreCorto"></uni-accordion-item>
    <uni-accordion-item name="Área de Solicitud" [description]="creationRequest.area.sNombre"></uni-accordion-item>
    <uni-accordion-item name="Tipo" [description]="creationRequest.type.sNombre"></uni-accordion-item>
    <uni-accordion-item name="SubTipo" [description]="creationRequest.subtype.sNombre"></uni-accordion-item>
  </uni-accordion-group>
  <uni-accordion-group *ngIf="false" heading="Datos de la Solicitud">
    <uni-accordion-item name="Etapa" [description]="creationRequest.dtCreation | date : 'dd/MM/yyyy'"></uni-accordion-item>
    <uni-accordion-item
      name="Cantidad de Facturas"
      [description]="creationRequest.dtExpiration | date : 'dd/MM/yyyy'"
    ></uni-accordion-item>
    <uni-accordion-item name="Monto" [description]="creationRequest.priority.sNombre"></uni-accordion-item>
    <uni-accordion-item name="Cédula" [description]="creationRequest.sDescription"></uni-accordion-item>
    <uni-accordion-item name="Tipo Cliente" [description]="creationRequest.sDescription"></uni-accordion-item>
  </uni-accordion-group>

  <uni-accordion-group
    heading="Documentos de la Solicitud {{
      getDocumentsCount() ? ': ' + getDocumentsCount() + ' (' + filesSizeMegaBytes1X1 + ' mbs)' : ''
    }}"
  >
    <ng-container *ngIf="!getDocumentsCount()">Sin Documentos</ng-container>
    <ng-container *ngIf="getDocumentsCount()">
      <table style="width: 100%">
        <caption></caption>
        <thead>
          <tr>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let group of filesGroups; index as i">
            <tr>
              <td colspan="2" style="text-align: right; font-size: 12px">
                <span
                  style="
                    background-color: #17a2b8;
                    color: white;
                    padding: 1px 6px;
                    box-sizing: border-box;
                    margin: 0;
                    border-radius: 5px 5px 0 0;
                    font-size: 11px;
                  "
                >
                  {{ this.getFilesSizeMegaBytes1x1(group.files) }} mbs
                </span>
              </td>
            </tr>
            <tr style="background-color: #e8edf7; color: #041e9a; border-radius: 4px">
              <td colspan="2" style="text-align: left; padding: 5px">{{ group.name }} : {{ group.files.length }}</td>
            </tr>
            <ng-container *ngFor="let file of group.files; index as k">
              <ng-container *ngIf="isMainFile(file)">
                <tr style="border-bottom: 1px solid rgba(0, 0, 0, 0.05)">
                  <td colspan="2" style="text-align: left; padding: 5px; font-size: 12px">
                    {{ file?.file?.name }}<br />
                    <span
                      style="
                        background-color: #e8edf7;
                        padding: 1px 6px;
                        box-sizing: border-box;
                        border-radius: 50px;
                        font-size: 10px;
                      "
                    >
                      {{ getSizeMegaBytes(file?.file?.object?.size, 3) }} mb
                    </span>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="!isMainFile(file)">
                <tr style="border-bottom: 1px solid rgba(0, 0, 0, 0.05)">
                  <td colspan="2" style="text-align: left; padding: 5px">
                    {{ file?.file?.name }}<br />
                    <span
                      style="
                        background-color: #e8edf7;
                        padding: 1px 6px;
                        box-sizing: border-box;
                        border-radius: 50px;
                        font-size: 10px;
                      "
                    >
                      {{ getSizeMegaBytes(file?.file?.object?.size, 3) }} mb
                    </span>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </uni-accordion-group>
</uni-accordion>
